import { Routes } from '@angular/router';
import { authRoutes, joinRoutes, dspRoutes, sspRoutes, localhostRoutes } from './app.routes.domain';

// Domain-specific routes configuration
function getDomainSpecificRoutes(): Routes {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  
  // Check for localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('localhost')) {
    return [
      ...localhostRoutes,
      {
        path: '**',
        redirectTo: '/login',
        pathMatch: 'full'
      }
    ];
  }

  // Dynamic domain routing
  if (hostname.startsWith('login.')) {
    return [
      ...authRoutes,
      {
        path: '**',
        redirectTo: '/login',
        pathMatch: 'full'
      }
    ];
  }

  if (hostname.startsWith('join.')) {
    return [
      ...joinRoutes,
      {
        path: '**',
        redirectTo: '/register',
        pathMatch: 'full'
      }
    ];
  }

  if (hostname.startsWith('dsp.')) {
    return [
      ...dspRoutes,
      {
        path: '**',
        redirectTo: '/main',
        pathMatch: 'full'
      }
    ];
  }

  if (hostname.startsWith('ssp.')) {
    return [
      ...sspRoutes,
      {
        path: '**',
        redirectTo: '/main',
        pathMatch: 'full'
      }
    ];
  }

  // Default fallback (treat as localhost/dev or main landing)
  return [
    ...localhostRoutes,
    {
      path: '**',
      redirectTo: '/login',
      pathMatch: 'full'
    }
  ];
}

export const routes: Routes = getDomainSpecificRoutes();
